import { Rgb } from '@schibsted-nmp/advertising-shared';

import { debug as _debug } from '../.debug.js';

export const debug = _debug.withLabel('Event', Rgb.purple, Rgb.lavender);
